module.exports = __webpack_public_path__ + "bd72db403760998af27aab6020eb8e26.png";